import React, { useState, useRef } from "react";
import { PauseIcon, PlayIcon } from "@radix-ui/react-icons";
import audioFile from "../../sample.mp3";

const AudioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(audioFile));

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div style={styles.container}>
      <button onClick={togglePlayPause} style={styles.button}>
        {isPlaying ? (
          <PauseIcon width="20" height="20" style={styles.icon} />
        ) : (
          <PlayIcon width="20" height="20" style={styles.icon} />
        )}
      </button>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "40px",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: "green",
    border: "none",
    cursor: "pointer",
    outline: "none",
    transition: "background-color 0.3s",
  },
  icon: {
    color: "white",
  },
};

export default AudioPlayer;